import { parseToken } from './detector'

// Encoded fact contradictions. Each rule declares two mutually exclusive groups
// of facts: when a property's factsheet contains at least one fact from each
// group, the rule is violated.
//
// Tokens are kept as the original product-spec strings (f<factId>,
// f<factId>:a<attrId>, f<factId>:a<attrId>.value) so this list stays
// directly comparable to the spec. This is the single place to encode new
// contradictions. Ids that are unknown to the current blueprint are tolerated
// (they simply never match).
const rawRules = [
  {
    id: 'family-vs-adults',
    // Family-related facts
    groupA: [
      'f269', 'f389', 'f403', 'f141', 'f10', 'f56', 'f57', 'f924', 'f858', 'f26',
      'f854', 'f870', 'f794', 'f800', 'f131', 'f613', 'f806', 'f703', 'f402', 'f817',
      'f1', 'f6', 'f7', 'f946', 'f4', 'f98', 'f708', 'f710', 'f437',
      'f65:a608', 'f65:a368', 'f65:a414', 'f65:a46', 'f64:a46', 'f58:a414', 'f50:a583',
      'f40:a583', 'f43:a583', 'f176:a409', 'f809:a409', 'f895:a367', 'f151:a46',
      'f150:a46', 'f899:a367', 'f197:a414', 'f197:a640', 'f197:a368', 'f909:a368',
      'f909:a414', 'f196:a368', 'f196:a414', 'f233:a367',
      'f479:a368',
    ],
    // Adults-only facts
    groupB: ['f251', 'f385'],
  },
  {
    id: 'outskirts-vs-central',
    // On the outskirts
    groupA: ['f351', 'f352'],
    // Central location
    groupB: ['f90'],
  },
]

// parse token strings once at module load so per-action detection is just
// array filtering.
export const contradictionRules = rawRules.map((rule) => ({
  id: rule.id,
  groupA: rule.groupA.map(parseToken),
  groupB: rule.groupB.map(parseToken),
}))
